<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  
  export default {
    components: { datepicker },
    props: {
      webFormRespostasRelacaoFundacao: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        relacaoFundacao: this.campos(),
      }
    },
    methods: {
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      deletar(indice) {
        this.webFormRespostasRelacaoFundacao.splice(indice, 1);
      },
      editar(indice) {
        const relacaoFundacao = this.webFormRespostasRelacaoFundacao[indice];
        this.webFormRespostasRelacaoFundacao.splice(indice, 1);

        this.relacaoFundacao.id = relacaoFundacao.id;
        this.relacaoFundacao.nomeIntegrante = relacaoFundacao.nomeIntegrante;
        this.relacaoFundacao.cargoIntegrante = relacaoFundacao.cargoIntegrante;
        this.relacaoFundacao.grauParentesco = relacaoFundacao.grauParentesco;
        this.relacaoFundacao.nomeFuncionario = relacaoFundacao.nomeFuncionario;
        this.relacaoFundacao.cargoFuncionario = relacaoFundacao.cargoFuncionario;
      },
      async adicionar() {
        const copiaRelacaoFundacao = Object.assign(this.relacaoFundacao);
        
        this.relacaoFundacao = this.campos();
        
        this.webFormRespostasRelacaoFundacao.push(copiaRelacaoFundacao);

        this.$validator.reset();
      },
      campos() {
        return {
          id: '',
          nomeIntegrante: '',
          cargoIntegrante: '',
          grauParentesco: '',
          nomeFuncionario: '',
          cargoFuncionario: '',
        }
      }
    }
  }
</script>

<template>
  <div>
    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th>Nome do Integrante</th>
            <th>Cargo</th>
            <th>Grau Parentesco</th>
            <th>Nome Funcionário</th>
            <th>Cargo Funcionário</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(relacaoFundacao, indice) in webFormRespostasRelacaoFundacao">
            <td>{{ relacaoFundacao.nomeIntegrante }}</td>
            <td>{{ relacaoFundacao.cargoIntegrante }}</td>
            <td>{{ relacaoFundacao.grauParentesco }}</td>
            <td>{{ relacaoFundacao.nomeFuncionario }}</td>
            <td>{{ relacaoFundacao.cargoFuncionario }}</td>
            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="webFormRespostasRelacaoFundacao.length === 0">
            <td colspan="5" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('nomeIntegrante')}">
          <label class="control-label" for="nomeIntegrante">Nome do Integrante</label>

          <input type="text"
                 class="form-control"
                 id="nomeIntegrante"
                 maxlength="100"
                 v-model="relacaoFundacao.nomeIntegrante"
                 data-vv-name="nomeIntegrante"
                 data-vv-as="nome integrante"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('nomeIntegrante')">{{ errors.first('nomeIntegrante') }}</p>
        </div>
      </div>


        <div class="col-lg-2">
          <div class="form-group required" :class="{'has-error': errors.has('cargoIntegrante')}">
            <label class="control-label" for="cargoIntegrante">Cargo do Integrante</label>

            <input type="text"
                   class="form-control"
                   id="cargoIntegrante"
                   maxlength="30"
                   v-model="relacaoFundacao.cargoIntegrante"
                   data-vv-name="cargoIntegrante"
                   data-vv-as="cargo integrante"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('cargoIntegrante')">{{ errors.first('cargoIntegrante') }}</p>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group required" :class="{'has-error': errors.has('grauParentesco')}">
            <label class="control-label" for="grauParentesco">Grau Parentesco</label>

            <input type="text"
                   class="form-control"
                   id="grauParentesco"
                   maxlength="20"
                   v-model="relacaoFundacao.grauParentesco"
                   data-vv-name="grauParentesco"
                   data-vv-as="grau parentesco"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('grauParentesco')">{{ errors.first('grauParentesco') }}</p>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="form-group required" :class="{'has-error': errors.has('nomeFuncionario')}">
            <label class="control-label" for="nomeFuncionario">Nome do Funcionário</label>

            <input type="text"
                   class="form-control"
                   id="nomeFuncionario"
                   v-model="relacaoFundacao.nomeFuncionario"
                   maxlength="100"
                   data-vv-name="nomeFuncionario"
                   data-vv-as="nome funcionario"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('nomeFuncionario')">{{ errors.first('nomeFuncionario') }}</p>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group required" :class="{'has-error': errors.has('cargoFuncionario')}">
            <label class="control-label" for="cargoFuncionario">Cargo do Funcionário</label>

            <input type="text"
                   class="form-control"
                   id="cargoFuncionario"
                   v-model="relacaoFundacao.cargoFuncionario"
                   maxlength="30"
                   data-vv-name="cargoFuncionario"
                   data-vv-as="cargo funcionario"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('cargoFuncionario')">{{ errors.first('cargoFuncionario') }}</p>
          </div>
        </div>
      </div>
    

      <div class="row"> 
        <div class="col-lg-12">
          <div class="form-group">
            <button type="button"
                    class="btn btn-success"
                    @click="validar">
              <i class="fa fa-plus"></i> Adicionar integrante
            </button>
          </div>
        </div>
      </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-fornecedor/componentes/compartilhado/WebFormRespostasRelacaoFundacao.vue